"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEY_DOWN_HANDLER_CONFIG_OPTION = exports.DEFAULT_SEPARATORS = exports.JS__TOKEN__DELETE_BUTTON__CLASS_NAME = void 0;
const TokenInput_1 = __importDefault(require("./TokenInput"));
const constants_1 = require("./constants");
Object.defineProperty(exports, "JS__TOKEN__DELETE_BUTTON__CLASS_NAME", { enumerable: true, get: function () { return constants_1.JS__TOKEN__DELETE_BUTTON__CLASS_NAME; } });
Object.defineProperty(exports, "KEY_DOWN_HANDLER_CONFIG_OPTION", { enumerable: true, get: function () { return constants_1.KEY_DOWN_HANDLER_CONFIG_OPTION; } });
Object.defineProperty(exports, "DEFAULT_SEPARATORS", { enumerable: true, get: function () { return constants_1.DEFAULT_SEPARATORS; } });
exports.default = TokenInput_1.default;
